// Copyright 2020-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import styled from 'styled-components';

import { flexbox, space, layout, FlexboxProps, SpaceProps, LayoutProps } from 'styled-system';

// Combine the props from styled-system
type FlexProps = FlexboxProps & SpaceProps & LayoutProps;

export const Flex = styled.div<FlexProps>`
  display: flex;
  ${flexbox} // Enables flexbox-related props like alignItems, justifyContent
  ${space}   // Enables shorthand spacing props like mb, mr, px
  ${layout}  // Enables layout-related props like width, height
`;

export const StyledList = styled.dl`
  font-size: 1rem;

  dt {
    display: inline-block;
    margin-bottom: 0.75rem;
    margin-right: 0.5rem;

    &::after {
      content: ':';
    }
  }

  dd {
    display: inline-block;
    font-weight: 600;
  }
`;
